import Typography from "@mui/material/Typography";
import { ContentSchedule } from "entities/contentSchedule/types";
import { MODULE_TYPE_LABELS } from "entities/modules/constants";
import { PageModuleStatus } from "entities/pages/types";
import { StyledNameCell } from "shared/components/CollapsibleTable/styled";
import { TableColumn } from "shared/components/CollapsibleTable/types";
import CustomTooltip from "shared/components/CustomTooltip";
import DropdownList from "shared/components/DropdownList";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { StarsIcon } from "shared/theme/icons/StarsIcon";
import { formatScheduledDate } from "shared/utils/formatScheduledDate";
import ContentStatusBadge from "./components/ContentStatusBadge";
import { ScheduleCell, EmptyRowCell, ScheduleRow } from "./styled";

export const contentScheduleColumns: TableColumn<ContentSchedule>[] = [
  { key: "brandId", title: "Brand", width: "10%" },
  { key: "pageName", title: "Page", width: "10%" },
  { key: "event", title: "Event", width: "15%" },
  { key: "scheduledStartAt", title: "Start", width: "10%" },
  { key: "scheduledEndAt", title: "End", width: "10%" },
  { key: "type", title: "Content Type", width: "15%" },
  { key: "name", title: "Title", width: "15%" },
  { key: "status", title: "Status", width: "10%" },
  { key: "actions", title: "", width: "5%" },
];

export const renderModuleRow = ({
  module,
  handleEdit,
  updateContentModuleStatus,
}: {
  module: ContentSchedule;
  handleEdit: (module: ContentSchedule) => void;
  updateContentModuleStatus: (params: {
    brandId: string;
    pageId: string;
    moduleId: string;
    status: PageModuleStatus;
  }) => void;
}) => {
  if (module.isEmpty) {
    return (
      <ScheduleRow key={module.id}>
        <EmptyRowCell colSpan={contentScheduleColumns.length}>
          <Typography variant="body2" color="text.secondary">
            {module.message}
          </Typography>
        </EmptyRowCell>
      </ScheduleRow>
    );
  }

  const actionItems = [
    {
      title: "Edit",
      onClick: () => handleEdit(module),
    },
  ];

  return (
    <ScheduleRow key={module.id}>
      <ScheduleCell
        width={contentScheduleColumns[0].width}
        textTransform="capitalize"
      >
        {module.brandId}
      </ScheduleCell>
      <ScheduleCell width={contentScheduleColumns[1].width}>
        {module.pageName}
      </ScheduleCell>
      <ScheduleCell width={contentScheduleColumns[2].width}>
        {module.relatedEvent ? (
          <CustomTooltip title={module.relatedEvent.name} width="auto">
            <StyledNameCell>{module.relatedEvent.name}</StyledNameCell>
          </CustomTooltip>
        ) : (
          "-"
        )}
      </ScheduleCell>
      <ScheduleCell width={contentScheduleColumns[3].width}>
        {formatScheduledDate(module.scheduledStartAt)}
      </ScheduleCell>
      <ScheduleCell width={contentScheduleColumns[4].width}>
        {formatScheduledDate(module.scheduledEndAt)}
      </ScheduleCell>
      <ScheduleCell width={contentScheduleColumns[5].width}>
        <FlexCenter gap="0.5rem">
          {MODULE_TYPE_LABELS[module.type] || module.type}{" "}
          {module.isAiGenerated ? <StarsIcon variant="colored" /> : null}
        </FlexCenter>
      </ScheduleCell>
      <ScheduleCell width={contentScheduleColumns[6].width}>
        <CustomTooltip title={module.name} width="auto">
          <StyledNameCell>{module.name}</StyledNameCell>
        </CustomTooltip>
      </ScheduleCell>
      <ScheduleCell width={contentScheduleColumns[7].width}>
        <ContentStatusBadge
          module={module}
          handleStatus={updateContentModuleStatus}
        />
      </ScheduleCell>
      <ScheduleCell width={contentScheduleColumns[8].width} align="right">
        <DropdownList items={actionItems} />
      </ScheduleCell>
    </ScheduleRow>
  );
};
